import React, { useState } from "react";
import {FaEnvelope ,FaPhone ,FaBars,FaWhatsapp, FaTimes, FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaSearch } from "react-icons/fa";
import "./Navbar.css"; // Import CSS
import logo from '../assets/last_final_png.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      {/* Left - Logo */}
      <img src={logo} alt="Logo" className="logo" />

      {/* Center - Navbar Links (Desktop Only) */}
      <ul className="nav-links">
        <li>
          <a onClick={() => handleScroll('hero')} className="nav-link btn">
            HOME
          </a>
        </li>
        <li>
          <a onClick={() => handleScroll('our-products')} className="nav-link btn">
            PRODUCTS
          </a>
        </li>
        <li>
          <a onClick={() => handleScroll('custom-branding')} className="nav-link btn">
            CUSTOM-BRAND
          </a>
        </li>
        <li>
          <a onClick={() => handleScroll('about')} className="nav-link btn">
            ABOUT
          </a>
        </li>
        {/* <li>
          <a onClick={() => handleScroll('co-branding')} className="nav-link btn">
            CO-BRAND
          </a>
        </li>        */}
        <li>
          <a onClick={() => handleScroll('contact-us')} className="nav-link btn">
            CONTACT
          </a>
        </li>
      </ul>

      {/* Right - Social Icons (Desktop Only) */}
      <div className="social-icons desktop-only">
        <a href="mailto:lusorafnb@gmail.com" className="icon email-icon">
          <FaEnvelope />
        </a>
        <a href="tel:+919829326555" className="icon phone-icon">
          <FaPhone />
        </a>
        <a href="https://wa.me/919829326555" className="icon whatsapp-icon">
          <FaWhatsapp />
        </a>
        <a href="https://www.facebook.com/your-facebook-page" className="icon" target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>
        <a href="https://www.instagram.com/_lusora_/" className="icon" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        {/* <a href="https://twitter.com/your-twitter-handle" className="icon" target="_blank" rel="noopener noreferrer">
          <FaTwitter />
        </a> */}
      </div>

      {/* Hamburger Button (Mobile) */}
      <button className="hamburger" onClick={() => setIsOpen(true)}>
        <FaBars />
      </button>

      {/* Sidebar for Mobile */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setIsOpen(false)}>
          <FaTimes />
        </button>

        {/* Sidebar Links */}
        <ul>
          <li><a onClick={() => handleScroll('hero')} className="nav-link">HOME</a></li>
          <li><a onClick={() => handleScroll('our-products')} className="nav-link">PRODUCTS</a></li>
          <li><a onClick={() => handleScroll('custom-branding')} className="nav-link">CUSTOM-BRAND</a></li>
          <li><a onClick={() => handleScroll('about')} className="nav-link">ABOUT</a></li>
          {/* <li><a onClick={() => handleScroll('co-branding')} className="nav-link">CO-BRAND</a></li>          */}
          <li><a onClick={() => handleScroll('contact-us')} className="nav-link">CONTACT</a></li>
        </ul>

        {/* Social Media Icons in Sidebar (Mobile) */}
        <div className="sidebar-social-icons">
          <a href="mailto:lusorafnb@gmail.com" className="icon email-icon">
            <FaEnvelope />
          </a>
          <a href="tel:+919413188887" className="icon phone-icon">
            <FaPhone />
          </a>
          <a href="https://wa.me/919829326555" className="icon whatsapp-icon">
            <FaWhatsapp />
          </a>
          <a href="https://www.facebook.com/your-facebook-page" className="icon" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/_lusora_/" className="icon" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
